export const SPACE_NOT_FOUND = "Space not found.";
export const SPACE_PERMISSION_DENIIED = "Space permission denied.";
export const SPACE_SHARING_DISABLED = "Space is disabled.";
export const SPACE_GUEST_MODE_DISABLED = "Guest mode is disabled.";
export const SPACE_INBOX_PERMISSION_DENIED = "Inbox permission denied.";
export const ENTITY_NOT_FOUND = "Entity not found.";
export const ENTITY_NOT_LOADING = "Error loading entity.";
